module.exports = __webpack_public_path__ + "assets/img/20230418.872ba579.png";